<div class="card p-2 image-preview-container" [ngClass]="{
    'three-images-container': getDisplayImages().length === 3,
    'size-sm': size === 'sm',
    'size-md': size === 'md',
    'size-lg': size === 'lg',
    'locked': restricted
  }" [title]="getTooltip()">
  <div *ngIf="restricted" class="no-images-state locked-state">
    <i class="ti ti-lock no-image-icon"></i>
    <span class="no-image-text">Restricted</span>
  </div>

  <div *ngIf="!restricted && !hasImages" class="no-images-state">
    <i class="ti no-image-icon" [class]="'ti ti-' + getNoContentIcon()"></i>
    <span class="no-image-text">{{ getNoContentText() }}</span>
  </div>

  <div *ngIf="!restricted && hasImages" class="images-preview ">
    <div class="image-grid gap-2">
      <div *ngFor="let imageUrl of getDisplayImages(); let i = index" class="image-thumbnail"
        [class.single-image]="getDisplayImages().length === 1" [class.two-images]="getDisplayImages().length === 2"
        [class.three-images]="getDisplayImages().length === 3">
        <img (click)="onImageClick($event, i)" [src]="imageUrl" [alt]="getImageAltText(i)" class="thumbnail-img"
          loading="lazy" />

        <div *ngIf="i === 2 && getRemainingCount() > 0" class="more-images-overlay">
          <span class="more-count">+{{ getRemainingCount() }}</span>
        </div>
      </div>
    </div>
  </div>
</div>